/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'etc': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M294.4 320h435.2v64H294.4zm140.8 320h51.2v153.6h38.4V640H576v-38.4H435.2zm166.4 27.6v60c0 36.5 29.5 66 66 66h62v-38.4h-61.3c-15.6 0-28.3-12.7-28.3-28.3v-58.6c0-15.6 12.7-28.3 28.3-28.3h61.3v-38.4h-62c-36.5 0-66 29.5-66 66z"/><path pid="1" d="M627.2 115.2L588.8 64H435.2l-38.4 51.2H166.4v793.6h691.2V115.2H627.2zm166.4 729.6H230.4V243.2h563.2v601.6z"/><path pid="2" d="M294.4 460.8h179.2v64H294.4zm38.4 332.8h76.8v-38.4h-76.8v-38.4h76.8v-38.4h-76.8V640h76.8v-38.4H294.4v192h38.4z"/>'
  }
})
